import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-pesquisa',
  templateUrl: './pesquisa.component.html',
  styleUrls: ['./pesquisa.component.css']
})
export class PesquisaComponent implements OnInit {

  config: any = {}

  constructor(
    private configService: ConfigService,
    private titleService: Title
  ) {
    this.getConfig()
  }

  ngOnInit(): void {
    
  }

  getConfig() {
    this.configService.config().subscribe(
      data => {
        this.config = data
        this.titleService.setTitle('Pesquisa Produto | ' + data.nome)
      }, err => {
      }
    )
  }
}
